import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';
import { AnalyticsService } from 'src/app/service/analytics.service';

@Component({
  selector: 'app-varroc-connect-hardware',
  templateUrl: './varroc-connect-hardware.component.html',
  styleUrls: ['./varroc-connect-hardware.component.scss'],
  standalone: false
})
export class VarrocConnectHardwareComponent implements OnInit {

  Images = IMAGES
  SupportEmail = SUPPORT_EMAIL;
  constructor(private analytics: AnalyticsService) { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

  onViewProduct(product: string) {
    this.analytics.trackUserInteraction(`view_product_${product}`, `view_${product}`, 'user123');
  }

  onClickDemo(product: string) {
    this.analytics.trackUserInteraction(`click_demo_${product}`, `ask_demo_${product}`, 'user123');
  }

}
